import { SynonymGroup } from "@/models/synonym-group/synonymGroup";
import { Switch } from "@capacit-com/lara-law-shared-ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "@capacit-com/lara-law-shared-ui";
import { forwardRef } from "react";

type Props = {
  synonymGroup: SynonymGroup;
  isToggled: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

const SynonymGroupItem = forwardRef<HTMLDivElement, Props>(
  ({ isToggled, onToggle, synonymGroup, disabled }, ref) => {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            ref={ref}
            className={`flex flex-col hover:bg-accent hover:text-accent-foreground p-2 rounded-md gap-1 m-1 group transition-all duration-200 cursor-pointer ${
              disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={onToggle}
          >
            <div className="flex w-full text-[10px] text-muted-foreground items-center gap-2">
              <Switch
                checked={isToggled}
                disabled={disabled}
                aria-label={isToggled ? "Deaktiver synonym" : "Aktiver synonym"}
              />
              <span className="font-mono text-sm text-muted-foreground group-hover:text-accent-foreground">
                {synonymGroup.canonicalTerm}
              </span>
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="left">
          <h3>Synonymer:</h3>
          <ol className="list-decimal pl-5">
            {synonymGroup.synonyms
              .filter((item) => item.active)
              .map((item) => (
                <li>{item.original}</li>
              ))}
          </ol>
        </TooltipContent>
      </Tooltip>
    );
  }
);

export default SynonymGroupItem;
